<div class="dialog">
  @let dimensions = versionData() | assetVersionDimensions;
  <div
    class="image"
    [style.aspect-ratio]="mode() === 'longPress' ? dimensions?.width / dimensions?.height : undefined"
    [class.vertical]="mode() === 'longPress' ? dimensions?.width < dimensions?.height : undefined"
  >
    @if (mode() === 'longPress') {
      @for (size of allowedSizes(); track size.name) {
        @if (currentSize() === size.name) {
          <img [src]="imageUrlWithDownload()" [attr.allow-link-preview]="true" alt="" />
        }
      }
    } @else {
      <div class="fake-image">
        <img [src]="noPreviewIcon()" alt="" />
      </div>
    }

    <div class="size-selector">
      <select [(ngModel)]="currentSize" id="size-selector" (ngModelChange)="saveSize(currentSize())">
        @for (size of allowedSizes(); track size.name) {
          <option [value]="size.name">
            {{ size.name | capitalize }}
          </option>
        }
      </select>
      <label for="size-selector">
        <span>
          {{ currentSize() | capitalize }}
          ({{ urlExtension() }}, {{ downloadSize() | dataUnitsBigInt }})
        </span>

        <app-svg src="/assets/icons/16/chevron-down.svg"> </app-svg>
      </label>
    </div>
  </div>

  @if (mode() === 'longPress') {
    <img src="/assets/icons/special/ios-long-press.svg" class="long-press-icon" alt="" />
    <p><b>Long-press</b> on the image above and choose <b>Save to Photos</b>.</p>
  } @else {
    <p>This file can’t be previewed. Click the button below to download.</p>
    <button appButton name="download" location="ios-download-dialog" weight="bold" [center]="true" shape="round">
      Download
    </button>
  }
</div>
